import { useState } from 'react';

const mobileRegex = new RegExp(
	/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|/
		.source +
		/midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/
			.source,
	'i',
);

// it detects if the user is using a mobile device (tablets are not considered mobile devices as chime does not support app for tablets)
export const useIsMobileDevice = () => {
	const [isMobileDevice] = useState(() => {
		if (typeof navigator !== 'undefined') {
			return mobileRegex.test(navigator.userAgent);
		}
		return false;
	});

	return isMobileDevice;
};
